module.exports = __webpack_public_path__ + "static/media/viewFCFimprovement.e4d2b5f4.svg";